<style>
  #wrapperStartpage td {
    vertical-align: middle;
    text-align: center;
  }
  @keyframes hideshow {
    0% { opacity: 0; }
    10% { opacity: 0.2; }
    20% { opacity: 0.4; }
    30% { opacity: 0.6; }
    40% { opacity: 0.8; }
    50% { opacity: 1; }
    60% { opacity: 0.8; }
    70% { opacity: 0.6; }
    80% { opacity: 0.4; }
    90% { opacity: 0.2; }
    100% { opacity: 0.1; }
  }
  .yourcabLogoAnim {
    animation: hideshow 1s ease infinite;
  }
</style>

<span>&copy; {{settings.getAppSetting('year')}} - {{ settings.getAppSetting('name') }}</span>

<span>-version 1.0.7  22-03-2026 19h</span>
<span *ngIf="!isConnected">{{status}}</span>

<div *ngIf="blocked" class="yourcabLogoAnim" style="    position: absolute;text-align: center;
    top: 50%;
    left: 50%;
    color: #ffffff;
    padding: 10px;">
</div>
